export default __webpack_public_path__ + "2db84ce94617ff3747149ff6427bc0cd.svg";